// AGC: WizardLotProgressBar - Phase 2 progress bar for lot creation wizard
import React from 'react'
import { useTranslation } from '../../hooks/useTranslation'

interface WizardLotProgressBarProps {
  currentStep: number // AGC: 1-5
  totalSteps?: number // AGC: defaults to 5
}

const STEP_KEYS = [
  'fields.wizardLotStep1of5',
  'fields.wizardLotStep2of5',
  'fields.wizardLotStep3of5',
  'fields.wizardLotStep4of5',
  'fields.wizardLotStep5of5',
]

export const WizardLotProgressBar: React.FC<WizardLotProgressBarProps> = ({
  currentStep,
  totalSteps = 5,
}) => {
  const { t } = useTranslation()

  return (
    <div className="px-4 py-3">
      <p className="text-xs text-emerald-600 dark:text-emerald-400 text-center mb-2 font-medium">
        {t('fields.wizardLotPhase')}
      </p>
      <div className="flex gap-2 mb-2">
        {Array.from({ length: totalSteps }, (_, i) => (
          <div
            key={i}
            className={`flex-1 h-1.5 rounded-full ${
              i < currentStep
                ? 'bg-emerald-500'
                : 'bg-gray-200 dark:bg-gray-700'
            }`}
          />
        ))}
      </div>
      <p className="text-xs text-gray-500 text-center">
        {t(STEP_KEYS[Math.max(0, Math.min(currentStep - 1, STEP_KEYS.length - 1))]!)}
      </p>
    </div>
  )
}
